export default __webpack_public_path__ + "static/media/charity.b4f4a69c.svg";